import { useQuery } from "react-query";
import { Get } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";

import { useNavigate } from "react-router-dom";
import { Customer } from "../../types/api/Customer";

export default (sellerOrgId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  return useQuery<Customer[]>(`customers_${sellerOrgId}`, async () => {
    return await Get<Customer[]>(
      `/api/order/organization/${sellerOrgId}/purchasers`,
      await getAccessTokenSilently()
    );
  });
};
